var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"data-cy":"aurora-auth-overlay","value":_vm.network.busy}},[_c('v-card',[_c('v-card-title',{attrs:{"data-cy":"aurora-auth-overlay-title"}},[_vm._v(" Logging you back in... ")]),_c('v-card-text',{staticClass:"text-center"},[_c('ProgressCircularTimeout')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }